export const request = (url, { method = 'GET', body } = {}) => {
  const token = document.querySelector('meta[name="csrf-token"]')
  return fetch(url, {
    method,
    headers: {
      'Content-Type': 'application/json',
      'Accept':       'application/json',
      'X-CSRF-Token': token ? token.content : '',
    },
    body: body ? JSON.stringify(body) : undefined,
  }).then(response => response.json().catch(() => ({})).then(data => ({ ok: response.ok, data })))
}
